import React, {useRef, useState} from "react";
import {Popover} from "antd";
import EmployeeOverview from "../employee-overview";
import server from "../../../../server";
import '../../../../styles/component/employee-overview/employee-overview.scss';

interface EmployeeOverviewPopoverProps {
    employeeId: string;
    uniqueKey?: string; // Useful when multiple rows exist for same employeeId, By this only one row open at a time with same employeeId
    children: React.ReactNode;
}

function EmployeeOverviewPopover(props: EmployeeOverviewPopoverProps) {

    const [activeRowKey, setActiveRowKey] = useState<string | null>(null); // Stores which popover is currently open
    const [data, setData] = useState<any>(null);

    // Stores timeout IDs. It is important because setTimeout() returns ID, We need that ID to stop timeout later using clearTimeout()
    const openTimeout = useRef<any>(null);
    const closeTimeout = useRef<any>(null);

    // use uniqueKey if provided otherwise use finalFetchId
    const popoverKey = props.uniqueKey || props.employeeId;

    const handleMouseEnter = () => {
        // .current stores current value
        clearTimeout(closeTimeout.current);

        // setTimeout -> Wait before opening (delay)
        openTimeout.current = setTimeout(async () => {
            try {
                const res = await server.employee.employeeBasicDetailsById(props.employeeId);
                setData(res);
                setActiveRowKey(popoverKey);
            } catch (e) {
                console.error("API error", e);
            }
        }, 1000);
    };

    const handleMouseLeave = () => {
        // clearTimeout ->  If user leaves quickly before delay ends then don't open popover.
        clearTimeout(openTimeout.current);

        if (activeRowKey === popoverKey) {
            closeTimeout.current = setTimeout(() => {
                setActiveRowKey(null);
                setData(null);
            }, 500);
        }
    };

    const handlePopoverEnter = () => {
        clearTimeout(closeTimeout.current);
    };

    const handlePopoverLeave = () => {
        closeTimeout.current = setTimeout(() => {
            setActiveRowKey(null);
            setData(null);
        }, 500);
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Popover
                open={activeRowKey === popoverKey}
                classNames={{
                    root: "employee-overview-popover",
                }}
                content={
                    activeRowKey === popoverKey && (
                        <div
                            onMouseEnter={handlePopoverEnter}
                            onMouseLeave={handlePopoverLeave}
                        >
                            {data ? (
                                <EmployeeOverview {...data} />
                            ) : (
                                <div style={{padding: 10}}>
                                    Loading...
                                </div>
                            )}
                        </div>
                    )
                }
            >
                {props.children}
            </Popover>
        </div>
    );
};

export default EmployeeOverviewPopover;